import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { Env } from "../../settings/Env";
import { ButtonUtils, ObjectBuilder, Image3D, ScrollViewer3D } from "@dreamcam/babylon-tools";
import { text } from "../../TextResources";
export class TagsPanelHelper {
    static createVerticalGap(mesh2d, parent) {
        const control = new Control("verticalGap");
        control.widthInPixels = 1;
        control.heightInPixels = mesh2d.m2px(Env.lobby.tagsPanel.videoTags.padding.gap);
        parent.addControl(control);
    }
    static createTagsPanel(mesh2d, parent) {
        const scrollViewer = new ScrollViewer3D("tagsPanelScrollViewer");
        parent.addControl(scrollViewer);
        const lm = Env.lobby.tagsPanel.lobbyMode;
        const sv = Env.lobby.tagsPanel.scrollView;
        scrollViewer.heightInPixels = mesh2d.m2px(mesh2d.height - lm.tabs.height - lm.tabs.top);
        scrollViewer.thickness = 0;
        scrollViewer.color = sv.colors.background;
        scrollViewer.barColor = sv.colors.bar;
        scrollViewer.hoverBarColor = sv.colors.hoverBar;
        scrollViewer.pressedBarColor = sv.colors.pressedBar;
        scrollViewer.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        scrollViewer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        scrollViewer.verticalBarPaddingInPixels = {
            left: mesh2d.m2px(sv.verticalBar.padding.left),
            right: mesh2d.m2px(sv.verticalBar.padding.right),
            top: mesh2d.m2px(sv.verticalBar.padding.top),
            bottom: mesh2d.m2px(sv.verticalBar.padding.bottom)
        };
        scrollViewer.barSizeInPixels = mesh2d.m2px(sv.verticalBar.size);
        scrollViewer.forceVerticalBar = false;
        const stackPanel = new StackPanel("tagsPanelStackPanel");
        stackPanel.isVertical = true;
        stackPanel.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        stackPanel.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        scrollViewer.addControl(stackPanel);
        return { scrollViewer, stackPanel };
    }
    static createNoTagsPanel(mesh2d, parent, callbacks) {
        const p = Env.lobby.tagsPanel.noTagsPanel;
        const stackPanel = new StackPanel("noTagGroupsPanel");
        stackPanel.isVertical = true;
        stackPanel.widthInPixels = mesh2d.m2px(p.width);
        stackPanel.heightInPixels = mesh2d.m2px(p.height);
        stackPanel.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        stackPanel.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        stackPanel.isVisible = false;
        parent.addControl(stackPanel);
        const image = new Image3D("noTagGroupsImage", p.image.url);
        image.widthInPixels = mesh2d.m2px(p.image.width);
        image.heightInPixels = mesh2d.m2px(p.image.height);
        image.paddingTopInPixels = mesh2d.m2px(p.image.padding.top);
        image.paddingBottomInPixels = mesh2d.m2px(p.image.padding.bottom);
        stackPanel.addControl(image);
        const description = ObjectBuilder.createTextBlock3D(mesh2d, "noTagGroupsText", text.lobby_live_tags_noTagGroupsDescription, p.description);
        stackPanel.addControl(description);
        const clearTagGroupsButton = ButtonUtils.CreateImgButton("noTagGroupsButton", p.clearTagGroupsButton.rectangleLayout, mesh2d);
        clearTagGroupsButton.widthInPixels = mesh2d.m2px(p.clearTagGroupsButton.width);
        clearTagGroupsButton.heightInPixels = mesh2d.m2px(p.clearTagGroupsButton.height);
        clearTagGroupsButton.paddingTopInPixels = mesh2d.m2px(p.clearTagGroupsButton.padding.top);
        clearTagGroupsButton.paddingBottomInPixels = mesh2d.m2px(p.clearTagGroupsButton.padding.bottom);
        clearTagGroupsButton.onClickObserver.add(callbacks.clearTagGroupsHandler);
        stackPanel.addControl(clearTagGroupsButton);
        const buttonCaption = ObjectBuilder.createTextBlock3D(mesh2d, "noTagGroupsButtonCaption", text.lobby_live_tags_clearTagGroupsButton, p.clearTagGroupsButton.caption);
        clearTagGroupsButton.addControl(buttonCaption);
        return { stackPanel };
    }
}
